export { default } from './PricingTable.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PricingTable/index.js